import React from "react";
import PropTypes from "prop-types";
import DOMPurify from "dompurify";
import { ExternalIcon } from "../icons";

const Teaser = ({
  imageSrc,
  imageSrcset,
  imageSizes,
  imageAlt,
  imageWidth,
  imageHeight,
  heading,
  url,
  text,
  isExternal,
  label,
  cta,
  onArtistPage,
  isExhibition,
  theme,
}) => {
  const className = "m-teaser";
  const sanitizedData = () => ({
    __html: DOMPurify.sanitize(heading, { FORBID_TAGS: ["p"] }),
  });

  /* eslint-disable react/jsx-no-target-blank */
  return (
    <a
      className={`${className} ${className}--${theme}`}
      href={url}
      target={isExternal ? "_blank" : "_self"}
      rel={isExternal ? "noopener norefferer" : ""}
    >
      {label && !isExhibition && (
        <span className={`${className}__label ${className}__label--bordered`}>
          {label}
        </span>
      )}
      <img
        className={`m-teaser__img is-loaded`}
        src={imageSrc}
        data-src={imageSrc}
        srcSet={imageSrcset}
        data-srcset={imageSrcset}
        sizes={imageSizes}
        alt={imageAlt}
        loading="lazy"
        width={imageWidth}
        height={imageHeight}
      />
      {theme === "overlay" && <div className="m-teaser__background" />}
      <div className="m-teaser__text-block">
        {label && isExhibition && !onArtistPage && (
          <span className={`${className}__label`}>{label}</span>
        )}
        <h3
          className={`${className}__heading`}
          dangerouslySetInnerHTML={sanitizedData()}
        />
        {text && (
          <p className={`${className}__text`}>
            <span className={`${className}__cta-text`}>{text}</span>
          </p>
        )}
        {cta && (
          <p className={`${className}__cta`}>
            <span className={`${className}__cta-text`}>{cta}</span>
            {isExternal && (
              <ExternalIcon className={`${className}__cta-icon`} />
            )}
          </p>
        )}
      </div>
    </a>
  );
};
/* eslint-enable react/jsx-no-target-blank */

Teaser.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  imageSrcset: PropTypes.string.isRequired,
  imageSizes: PropTypes.string.isRequired,
  imageAlt: PropTypes.string,
  imageWidth: PropTypes.number.isRequired,
  imageHeight: PropTypes.number,
  heading: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isExternal: PropTypes.bool,
  label: PropTypes.string,
  cta: PropTypes.string,
  isExhibition: PropTypes.bool,
  theme: PropTypes.oneOf(["default", "overlay"]),
  onArtistPage: PropTypes.bool,
};

Teaser.defaultProps = {
  theme: "default",
};

export default Teaser;
